export const splitEmailAddresses = (emailsString)=>{
    return emailsString.split(/[,; ]/).map((email)=>email.trim()).filter(Boolean);
};

//# sourceMappingURL=emails.js.map